export const htmlToText = (html: string): string => {
	if (!html) {
		return "";
	}
	return html.replace(/<[^>]*>/g, "")?.trim();
};
